import { QueryKeyFactory } from '@tanstack/react-query';

export const queryKeys = {
  // Campaigns
  campaigns: {
    all: (userEmail?: string) => ['campaigns', 'all', userEmail] as const,
    list: (userEmail?: string) => [...queryKeys.campaigns.all(userEmail), 'list'] as const,
    detail: (campaignId: string) => ['campaigns', 'detail', campaignId] as const,
  },

  // Leads
  leads: {
    list: (userEmail?: string, filters?: object) => ['leads', 'list', userEmail, filters] as const,
    minimal: (userEmail?: string, limit?: number) => ['leads', 'minimal', userEmail, { limit }] as const,
    byCampaign: (campaignId: string, userEmail?: string) => ['leads', 'campaign', campaignId, userEmail] as const,
    detail: (campaignId: string, leadId: string) => ['leads', 'detail', campaignId, leadId] as const,
    counts: (userEmail?: string) => ['leads', 'counts', userEmail] as const,
  },

  // Client Profile
  profile: {
    client: (userEmail: string) => ['profile', 'client', userEmail] as const,
  },

  // Users
  users: {
    byEmail: (email: string | null | undefined) => ['users', 'byEmail', email] as const,
  },

  // Admin Command (superadmin)
  admin: {
    overview: ['admin', 'overview'] as const,
    teams: ['admin', 'teams'] as const,
    user: (userId: string) => ['admin', 'user', userId] as const,
  },

  // Preferences
  preferences: {
    user: (userId: string) => ['preferences', 'user', userId] as const,
    team: (userId: string) => ['preferences', 'team', userId] as const,
    /** Seller registry (team pref `seller_ids`) — shared, email-agnostic. */
    teamSellerIds: ['preferences', 'team', 'seller_ids'] as const,
  },

  // Sellers (Team view registry actions)
  sellers: {
    /** Family root — invalidates every cached seller profile at once. */
    profileRoot: ['sellers', 'profile'] as const,
    /** Enriched lvl1 seller profile from get_lvl1_profile. */
    profile: (lvl1Id: string) => ['sellers', 'profile', lvl1Id] as const,
  },

  // Storage-backed UI state
  storage: {
    report: (path: string) => ['storage', 'report', path] as const,
    campaignReports: (campaignId: string, signature: string) => ['storage', 'campaignReports', campaignId, signature] as const,
    campaignResearch: (campaignId: string) => ['storage', 'campaignResearch', campaignId] as const,
  },
} satisfies QueryKeyFactory;
